
import {
    ISSUE_CARD_LIST,
    ISSUE_CARD_LIST_SUCCESS,
    ISSUE_CARD_LIST_FAILED,
    TRANSACTIONS,
    TRANSACTIONS_SUCCESS,
    TRANSACTIONS_FAILED,
} from './constants';

export const getIssueCards = (userId) => ({
    type: ISSUE_CARD_LIST,
    payload: { userId },
});

export const getIssueCardsSuccess = (card) => ({
    type: ISSUE_CARD_LIST_SUCCESS,
    payload: card,
});

export const getIssueCardsFailed = (error) => ({
    type: ISSUE_CARD_LIST_FAILED,
    payload: error,
});

export const getTransactions = (userId) => ({
    type: TRANSACTIONS,
    payload: { userId },
});

export const getTransactionsSuccess = (transactions) => ({
    type: TRANSACTIONS_SUCCESS,
    payload: transactions,
});

export const getTransactionsFailed = (error) => ({
    type: TRANSACTIONS_FAILED,
    payload: error,
});
